import { render, staticRenderFns } from "./ReportMaterialsDebitEditor.vue?vue&type=template&id=0764a604&"
import script from "./ReportMaterialsDebitEditor.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsDebitEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QItem,QCheckbox,QSelect,QItemSection,QList,QItemLabel,QInput,QField,QOptionGroup,QSeparator,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QIcon,QItem,QCheckbox,QSelect,QItemSection,QList,QItemLabel,QInput,QField,QOptionGroup,QSeparator,QCardActions,QBtn}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
